import { PageTitle } from 'components/PageTitle';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useFeatureFlagValue } from 'store/session/hooks';

import { useUserGroupLookup } from 'utils/multisite/hooks';

import { useDashboardViewContext } from './DashboardViewContext';
import { MultiSiteDashboard } from './MultiSiteDashboard';
import SingleSiteDashboard from './SingleSiteDashboard';

export const Dashboard = () => {
  const isMultisiteFunctionalityEnabled = useFeatureFlagValue(
    featureFlagKeys.isMultisiteFunctionalityAvailable,
  );
  const { availableGroups } = useUserGroupLookup();
  const { canToggleDashboardView, isMultisiteDashboardToggled } =
    useDashboardViewContext();

  const showMultisiteDashboard =
    isMultisiteFunctionalityEnabled &&
    availableGroups.length > 1 &&
    (!canToggleDashboardView || isMultisiteDashboardToggled);

  return (
    <>
      <PageTitle title="Dashboard" />
      {showMultisiteDashboard ? (
        <MultiSiteDashboard />
      ) : (
        <SingleSiteDashboard />
      )}
    </>
  );
};
